import { toast } from 'react-toastify';

const notify = () => toast("Dados enviados!");
const notify2 = () => toast("Obrigado!");

export { notify, notify2 };
